<div class="documents-form">
  <p class="text-gray-500 text-xs mb-3">
    <i class="pi pi-info-circle mr-1"></i>{{ 'docs.upload_limits' | transloco }}
  </p>
  <!-- Yuklangan fayllar — view mode -->
  <div *ngFor="let file of uploadedFiles" class="mb-3">
    <label class="block text-sm font-medium text-surface-700 mb-1">
      {{ getFileTypeLabel(file.spFileTypeId) }}
    </label>
    <div class="flex align-items-center gap-2 p-2 border-1 surface-border border-round surface-ground">
      <i class="pi pi-file-pdf text-red-500 text-xl"></i>
      <span class="text-surface-700 flex-1 white-space-nowrap overflow-hidden text-overflow-ellipsis">
        {{ file.fileOriginalName }}
      </span>
      <i class="pi pi-check-circle text-green-500"></i>
    </div>
  </div>

  <!-- Active upload qatori -->
  <div *ngIf="showUploadRow" class="documents-form__row flex flex-wrap align-items-end gap-3 mb-4">
    <div class="documents-form__dropdown flex-1 min-w-0" style="min-width: 12rem;">
      <label for="docType" class="block text-sm font-medium text-surface-700 mb-1">
        {{ "doc.type" | transloco }}
      </label>
      <p-dropdown
        [options]="applicantService.spService.spApplicantFileTypes"
        [(ngModel)]="currentSpFileTypeId"
        inputId="docType"
        [autoDisplayFirst]="false"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        [placeholder]="'doc.type' | transloco"
        styleClass="w-full"
        [disabled]="uploadInProgress"
      ></p-dropdown>
    </div>

    <div class="documents-form__upload flex-1 min-w-0" style="min-width: 14rem;">
      <label class="block text-sm font-medium text-surface-700 mb-1">
        {{ "docs.choose_a_file" | transloco }}
      </label>
      <p-fileUpload
        #fileUpload
        mode="basic"
        name="file"
        chooseIcon="pi pi-upload"
        [chooseLabel]="uploadInProgress ? ('loading' | transloco) : ('docs.choose_a_file' | transloco)"
        accept=".pdf"
        [customUpload]="true"
        [disabled]="uploadInProgress || !currentSpFileTypeId"
        (onSelect)="onFileSelect($event)"
      ></p-fileUpload>
    </div>
  </div>

  <!-- Barcha fayl turlari yuklangan -->
  <div *ngIf="!showUploadRow && uploadedFiles.length > 0" class="mb-4 text-green-600 flex align-items-center gap-2">
    <i class="pi pi-check-circle"></i>
    <span class="text-sm font-medium">{{ 'applicant.all_files_uploaded' | transloco }}</span>
  </div>

  <div class="flex gap-2 mt-4">
    <button
      pButton
      type="button"
      [label]="'btn.cancel' | transloco"
      icon="pi pi-times"
      class="p-button-outlined p-button-danger p-button-sm"
      (click)="onDialogClose()"
    ></button>
  </div>
</div>
